import React, {useEffect,useRef,useState} from 'react'
import {  Spinner } from "reactstrap";
import { Container, Row, Button, Col, Input } from "reactstrap";
import {getProdByID} from 'network/ApiAxiosMerchShop'
import QrReader from 'react-qr-reader';

function BarCodeScannerCamera(props) {
/*     useEffect(() => {
    focusInput()
    }, []); */
    const [searchTerm, setSearchTerm] = useState('')
    useEffect(() => {
        focusInput()
        const delayDebounceFn = setTimeout(() => {
        console.log('prod', searchTerm)
        if(searchTerm != '')  handleTextInput(searchTerm)
        }, 1000)

        return () => clearTimeout(delayDebounceFn)
    }, [searchTerm])




    const [camera, setCamera] = useState(false);
const qrRef = useRef(null);

  const handleError = (error)=>{
      console.log(error);
  }
  
  const handleScan = async (result)=>{
      if(result){
        setCamera(false)
        setSearchTerm(result)
      }
  }

    

    const [spinner, setSpinner] = useState(false);

    const inputReference = useRef(null);
    
    const focusInput =() => inputReference.current.focus();

    const handleTextInput = async(prod)=>{
        
        setSpinner(true)

        const prodResp = await getProdByID(prod)

        
            try {
                if(prodResp.data.success){
                    console.log(prodResp.data.response)
                    prod=prodResp.data.response
                    if(1 > prod.stock){throw 1}
                    if(!prod.stock){throw 2}
                    let cartItem = {_id : prod._id, qt: 1, prod:prod}
                    if(!localStorage.getItem("cartShop")){
                        localStorage.setItem("cartShop", JSON.stringify([cartItem]));
                        setSpinner(false)
                        setSearchTerm('')
                        props.updateCartQT(true)
                    }else{
                        let cartArray = JSON.parse(localStorage.getItem("cartShop"))
                        const checkExists = cartArray.findIndex(element => element._id == prod._id)
                        if(checkExists == -1){
                            cartArray.push(cartItem)
                            setSearchTerm('')
                        }else{
                            if(parseInt(cartArray[checkExists].qt) + 1 > prod.stock){
                                alert("Not enough tickets left. Too many in the cart already")
                            }else{
                                cartArray[checkExists].qt = parseInt(cartArray[checkExists].qt) + 1
                            }
                        }
                        localStorage.setItem("cartShop", JSON.stringify(cartArray))
                        setSearchTerm('')
                        setSpinner(false)
                        props.updateCartQT(true)
                    }
                }else{throw 3} 
           } catch(e) {
               if(e==1){
                   alert('Not enough stock of this item')
                   setSearchTerm('')
                   setSpinner(false)
               }else if(e==3){
                    alert('Invalid QR code or API error')
                    setSearchTerm('')
                    setSpinner(false)
               }else{
                   console.log(e)
                   alert('Something went wrong please scan again'); // error in the above string (in this case, yes)!
                   setSearchTerm('')
                   setSpinner(false)
   
               }
           } 
       
    }
  return (
    <Row className="text-center justify-content-center justify-content-middle" >
        {camera && <QrReader
            ref={qrRef}
            delay={500}
            onError={handleError}
            onScan={handleScan}
            style={{height:'200px',width:'200px'}}
            />}
            <Button onClick={()=>setCamera(true)}> Scan </Button>
        <Input type="text" innerRef={inputReference} value={searchTerm} placeholder="Scan Barcode" onChange={(e)=>setSearchTerm(e.target.value)} style={{width:"50%"}}/>
        {spinner &&
        <Spinner size="">
            Loading...
        </Spinner>}
    </Row>
  )
}

export default BarCodeScannerCamera